import { endpoint } from '../utils/fetching';

interface OpenalexWork {
  id: string;
  cited_by_count: number;
}

export interface OpenalexCitation {
  id: string;
  display_name: string;
  doi?: string;
}

export const OPENALEX_WORK_BY_DOI = endpoint({
  server: 'OPENALEX',
  path: 'works/:doi',
  params: {} as { doi: string; api_key?: string },
  schema: {} as OpenalexWork,
});

export const OPENALEX_CITATIONS_BY_ID = endpoint({
  server: 'OPENALEX',
  path: 'works',
  params: {} as { filter: string; api_key?: string },
  schema: {} as { results: OpenalexCitation[]; meta: any },
});

export const OPENALEX_FULLTEXT_SEARCH = endpoint({
  server: 'OPENALEX',
  path: 'works',
  params: {} as { filter: string; api_key?: string },
  schema: {} as { results: OpenalexCitation[]; meta: any },
});
